import BDatepicker from "../front/Modules/BDatepicker";

export default class BApp
{
	static init()
	{
		this.refresh();
	}

	static refresh()
	{
		window.dispatchEvent(new CustomEvent("resizeEnd"));
		BDatepicker.initialize();
	}

	static setUrl(url, title)
	{
		window.history.replaceState({
			url: url,
			title: title,
		}, title, url);
		if (title) {
			document.querySelector('head title').innerHTML = title;
		}
	}

	static redirect(url)
	{
		document.location.href = url;
	}

	static createElement(template, parentElement = "div")
	{
		let el = document.createElement(parentElement);
		el.innerHTML = template;

		return el.children[0];
	}
}
